import { useEffect, useState } from 'react';

const STATIC_FALLBACK_COUNTRIES: string[] = [
  'Australia',
  'Botswana',
  'Canada',
  'China',
  'France',
  'Germany',
  'India',
  'Japan',
  'Kenya',
  'Mozambique',
  'Namibia',
  'Nigeria',
  'South Africa',
  'Tanzania',
  'United Kingdom',
  'United States',
  'Zambia',
  'Zimbabwe',
];

const getCountriesFromIntl = (): string[] => {
  try {
    const intlWithSupportedValues = Intl as Intl.DateTimeFormatOptions & {
      supportedValuesOf?: (key: string) => string[];
    };
    if (!intlWithSupportedValues.supportedValuesOf) {
      return [];
    }

    const regionCodes = intlWithSupportedValues.supportedValuesOf('region');
    const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });

    return regionCodes
      .map((code) => displayNames.of(code))
      .filter((name): name is string => Boolean(name && name.length > 2))
      .sort((a, b) => a.localeCompare(b));
  } catch {
    return [];
  }
};

const useCountries = () => {
  const [countries, setCountries] = useState<string[]>([]);

  useEffect(() => {
    const localCountries = getCountriesFromIntl();
    if (localCountries.length > 0) {
      setCountries(localCountries);
    } else {
      setCountries(STATIC_FALLBACK_COUNTRIES);
    }
  }, []);

  return countries;
};

export default useCountries;
